import { CommonIcons, icons } from "../../components/common/CommonIcons";

const navConfig = [
  {
    title: 'Dashboard',
    path: 'dashboard',
    icon: <CommonIcons name={icons.dashboard} />
  },
  {
    title: 'Products',
    path: '',
    icon: <CommonIcons name={icons.products} />,
    children: [
      {
        title: 'Items',
        path: 'products',
      },
    ]
  },
];

export default navConfig;
